/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// @flow
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './styles.module.scss';
import GameResult from '../../components/GameResult';
import Card from '../../components/Card';
import Preloader from '../../components/Preloader';
import Toggler from '../../components/Toggler';
import Select from '../../components/Select';
import ResultStatistics from './ResultStatistics';
import { Button, ProgressBarSimilar, InputSearch } from '../../components';
import { sortCards } from '../../utils/game/sortRandomCards';
import Mistakes from './Mistakes';

const percentsResolverOptions = [
  { label: '% Action', value: 'action' },
  { label: '% Hands', value: 'hands' },
];

const getSearchRanks = (value = '') => (
  (value.match(/[AQJKT2-9]/gi) || []).join('').toUpperCase()
);

const normalizeSearchValue = (value = '', isPlo5 = false) => {
  const maxCards = isPlo5 ? 5 : 4;
  const normalized = value
    .replace(/[^AQJKT2-9SHDC]/gi, '')
    .replace(/[AQJKT]/gi, (card) => card.toUpperCase())
    .replace(/[SHDC]/gi, (suit) => suit.toLowerCase());
  const cards = normalized.match(/[AQJKT2-9][shdc]?/g) || [];

  return cards.slice(0, maxCards).join('');
};

type Props = {
  gameResults: any,
  limit: any,
  stackSize: any,
  position: any,
  getResultData: (any) => any,
  setSearchValue: (string) => any,
  searchValue: string,
  setGameResults: (any) => any,
  activeResultTab: number,
  setActiveResultTab: (number) => void,
  category: any,
  gameOption: any,
  isPlo5: boolean,
  seeRange: () => void,
  ggps: string,
  isFreeUser: boolean,
  setSelectedPercentsResolver?: () => void,
  selectedPercentsResolver?: any,
}
const ResultPanel = ({
  gameResults,
  getResultData,
  limit,
  stackSize,
  position,
  setSearchValue,
  searchValue,
  setGameResults,
  activeResultTab,
  setActiveResultTab,
  category,
  gameOption,
  isPlo5,
  seeRange,
  ggps,
  isFreeUser,
  selectedPercentsResolver,
  setSelectedPercentsResolver,
}: Props) => {
  const dispatch = useDispatch();
  const similar = useSelector((state) => state.game.similar);
  const percentage = useSelector((state) => state.game.percentage);
  const isLoadingSimilar = useSelector((state) => state.api.GET_SIMILAR.loading);
  const similarError = useSelector((state) => state.api.GET_SIMILAR.error);
  const gameData = useSelector((state) => state.game.gameData);
  const [selectedCategory, setSelectedCategory] = React.useState({ label: 'ALL', value: 'ALL' });
  const [selectedPercentage, setSelectedPercentage] = React.useState({});
  const [previousSavedPercentsResolver, setPreviousSavedPercentsResolver] = React.useState({});
  const [availableCategories, setAvailableCategories] = React.useState([]);
  const [selectedSimilar, setSelectedSimilar] = React.useState([]);

  const percentsResolverAvailable = () => {
    const categories = ['RFI', 'rfi', 'easyrfi'];
    const positions = ['bbvssblimp', 'sb'];
    if (positions.includes(position.value)) {
      return true;
    }
    return !categories.includes(category.value);
  };

  const handlePercents = () => {
    if (percentage) {
      const result = percentage.filter((el) => el?.category === selectedCategory.value);
      if (result.length === 0) {
        setSelectedPercentage({});
        if (selectedCategory.value !== 'ALL') {
          setSelectedCategory({ label: 'ALL', value: 'ALL' });
        }
      } else {
        setSelectedPercentage(result[0]);
      }
    } else {
      setSelectedPercentage({});
      // setSelectedCategory({ label: 'ALL', value: 'ALL' });
    }
  };

  const handleSimilar = () => {
    if (similar.length > 0) {
      if (selectedCategory.value === 'ALL') {
        setSelectedSimilar(similar);
      } else {
        const result = similar.filter((el) => el.category === selectedCategory.value);
        setSelectedSimilar(result);
      }
    } else {
      setSelectedSimilar([]);
      if (selectedCategory.value !== 'ALL') {
        setSelectedCategory({ label: 'ALL', value: 'ALL' });
      }
    }
  };

  React.useEffect(() => {
    const result = percentage?.map((el) => (
      { label: el?.category?.replace('RAINBOW', 'RNBW'), value: el?.category }
    ));
    setAvailableCategories(result);
    handlePercents();
    if (percentsResolverAvailable()) {
      if (selectedPercentsResolver.value !== 'other') {
        setPreviousSavedPercentsResolver(
          {
            label: selectedPercentsResolver.label,
            value: selectedPercentsResolver.value,
          },
        );
        setSelectedPercentsResolver({ label: 'Other', value: 'other' });
      }
    } else if ((selectedPercentsResolver.value === 'other')) {
      setSelectedPercentsResolver(previousSavedPercentsResolver);
      setPreviousSavedPercentsResolver({});
    }
  }, [percentage]);

  React.useEffect(() => {
    handleSimilar();
  }, [similar]);

  React.useEffect(() => {
    if (percentage) {
      handlePercents();
      handleSimilar();
    }
  }, [selectedCategory]);

  const handleSearchValue = (val: string) => {
    const ranks = getSearchRanks(val);
    const searchCards = val.match(/[AQJKT2-9][shdc]/g) || [];
    const expectedCards = isPlo5 ? 5 : 4;
    if (ranks.length < 4 && !isPlo5) {
      dispatch({ type: 'GET_SIMILAR_DROP' });
      return;
    }
    if (ranks.length < 5 && isPlo5) {
      dispatch({ type: 'GET_SIMILAR_DROP' });
      return;
    }
    dispatch({
      type: 'GET_SIMILAR',
      payload: {
        limit,
        stackSize,
        position: position.subValue,
        handType: ranks,
        tableHand: searchCards.length === expectedCards ? val : gameData?.combo || '',
        category: category.value,
        game: gameOption.value,
        ggps,
      },
    });
  };

  // eslint-disable-next-line consistent-return
  const handleInputSearch = async (e) => {
    if (!e) {
      setSearchValue('');
      dispatch({ type: 'GET_SIMILAR_DROP' });
      return;
    }
    const val = normalizeSearchValue(e?.target?.value, isPlo5);
    await setSearchValue(val);
    handleSearchValue(val);
  };

  const handleGetSimilar = (sort: 'fold' | 'call' | 'raise' | 'check') => {
    const ranks = getSearchRanks(searchValue);
    if (ranks.length < 4 && !isPlo5) return;
    if (ranks.length < 5 && isPlo5) return;
    dispatch({
      type: 'GET_SIMILAR',
      payload: {
        limit,
        stackSize,
        position: position.subValue,
        handType: ranks || sortCards(gameData.combo, isPlo5)?.map((val) => val?.[0]).join('') || '',
        tableHand: gameData?.combo || '',
        sort,
        category: category.value,
        game: gameOption.value,
      },
    });
  };

  return (
    <Card className={styles.resultPanelWrapper}>
      <ResultStatistics
        setGameResults={setGameResults}
        rightResults={getResultData(gameResults).right}
        allResults={getResultData(gameResults).all}
        wrongResults={getResultData(gameResults).wrong}
      />
      <div className={styles.delimeter} />
      <div className={styles.togglerWrapper}>
        <div
          className={`${styles.togglerOption} ${activeResultTab === 1 ? styles.activeTab : ''}`}
          onClick={() => setActiveResultTab(1)}
        >
          <div className={styles.togglerOptionText}>OVERVIEW</div>
        </div>
        <div
          className={`${styles.togglerOption} ${activeResultTab === 2 ? styles.activeTab : ''}`}
          onClick={() => setActiveResultTab(2)}
        >
          <div className={styles.togglerOptionText}>MISTAKES</div>
        </div>
      </div>
      {
        activeResultTab === 1
          ? (
            <>
              <InputSearch
                value={searchValue}
                onChange={handleInputSearch}
                isFreeUser={isFreeUser}
              />
              {availableCategories ? (
                <div className={styles.paddingH}>
                  <Toggler
                    selected={selectedCategory.value}
                    options={availableCategories}
                    onToggle={setSelectedCategory}
                    isFreeUser={isFreeUser}
                    className={`${styles.gameTogglerColor}`}
                    controlToggler
                    forResults
                  />
                  <Select
                    className={styles.adaptiveSelectComponent}
                    value={selectedCategory}
                    options={availableCategories}
                    onChange={setSelectedCategory}
                  />
                </div>
              ) : ''}
              {similar.length ? (
                <div className={styles.paddingH}>
                  <Toggler
                    selected={selectedPercentsResolver.value}
                    options={percentsResolverOptions}
                    onToggle={setSelectedPercentsResolver}
                    className={`${styles.gameTogglerColor} ${styles.mt12}`}
                    disabled={percentsResolverAvailable()}
                    isFreeUser={isFreeUser}
                    isPercentsResolver
                    controlToggler
                    forResults
                  />
                  <Select
                    className={styles.adaptiveSelectComponent}
                    value={selectedPercentsResolver.value}
                    options={percentsResolverOptions}
                    onChange={setSelectedPercentsResolver}
                    disabled={percentsResolverAvailable()}
                  />
                </div>
              ) : ''}
              {selectedPercentage?.category ? (
                <ProgressBarSimilar
                  handleGetSimilar={handleGetSimilar}
                  base={getResultData(gameResults).all}
                  percentage={selectedPercentage}
                  firstItemIsHighlighted={
                    selectedSimilar.length
                    && selectedSimilar.length > 0
                    && selectedSimilar[0].highlight
                  }
                />
              ) : '' }
              {isLoadingSimilar && <Preloader isLoading />}
              {!isLoadingSimilar && similarError && (
                <div className={styles.paddingH} role="alert">
                  <p>Could not load similar hands. Please try again.</p>
                  <Button use="ghost" onClick={() => handleSearchValue(searchValue)}>
                    Retry similar hands
                  </Button>
                </div>
              )}
              {!isLoadingSimilar && !similarError && (
                <>
                  <div className={styles.highlightedResultWrapper}>
                    {selectedSimilar.filter((result) => result.highlight).map((result) => (
                      <GameResult
                        actionRight={result?.action}
                        actions={result?.actions}
                        key={`highlighted-${result?.hand}`}
                        combo={result?.hand}
                        highlight={result?.highlight}
                        top={result?.top}
                        percentsResolver={selectedPercentsResolver.value}
                        limit={limit.value}
                        stackSize={stackSize.value}
                        isEasyRFI={category.value === 'easyrfi'}
                        isPlo5={isPlo5}
                      />
                    ))}
                  </div>
                  <div className={styles.resultsWrapper}>
                    <div style={{ width: '100%' }}>
                      {selectedSimilar.length ? selectedSimilar?.map((result) => (
                        // eslint-disable-next-line max-len
                        // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
                        <GameResult
                          actionRight={result?.action}
                          actions={result?.actions}
                          key={result?.hand}
                          combo={result?.hand}
                          highlight={result?.highlight}
                          top={result?.top}
                          percentsResolver={selectedPercentsResolver.value}
                          limit={limit.value}
                          stackSize={stackSize.value}
                          isEasyRFI={category.value === 'easyrfi'}
                          isPlo5={isPlo5}
                        />
                      )) : ''}
                    </div>
                  </div>
                </>
              )}
            </>
          ) : (
            <Mistakes
              category={category}
              stackSize={stackSize}
              seeRange={isFreeUser ? console.log : seeRange}
              isPlo5={isPlo5}
              isFreeUser={isFreeUser}
            />
          )
      }
    </Card>
  );
};

export default React.memo(ResultPanel);
